import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { LEADS_TEXT_PRIMARY, LEADS_TEXT_SECONDARY } from './leadsUi.styles';

/**
 * Checkbox de `apply_stock` (V3-3). Siempre arranca destildado: el Front
 * nunca cambia el stock sin que el usuario lo pida.
 *
 * @param {{ label: string, checked: boolean, disabled?: boolean,
 *   onChange: (checked: boolean) => void }} props
 */
export default function LeadInterestStockCheckbox({ label, checked, disabled = false, onChange }) {
  if (!label) return null;
  return (
    <FormControlLabel
      control={(
        <Checkbox
          size="small"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          inputProps={{ 'data-testid': 'interest-apply-stock' }}
          sx={{ color: LEADS_TEXT_SECONDARY, '&.Mui-checked': { color: '#489291' }, p: 0.75 }}
        />
      )}
      label={label}
      sx={{ mt: 1, ml: -0.75, '& .MuiFormControlLabel-label': { fontSize: '13px', color: LEADS_TEXT_PRIMARY } }}
    />
  );
}
